import { render, staticRenderFns } from "./SelectTag.vue?vue&type=template&id=63d1146e&"
import script from "./SelectTag.vue?vue&type=script&lang=js&"
export * from "./SelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports